// extracted by mini-css-extract-plugin
export default {"createBranchLink":"NoBranchesOrLinkedPullRequests-module__createBranchLink--_QIEZ"};